import SignInPage from "../components/SignUp/SignIn";
import AuthNavbar from "../components/common/AuthNavbar";
import styles from "./Userinfo.module.css";

export default function Login() {
  return (
    <div className={styles.root}>
      <AuthNavbar />
      <SignInPage />
    </div>
  );
}